import {Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppUtilityService } from './AppUtilityService';
import moment from 'moment/moment';
import { Router } from '@angular/router';
import { Location } from "@angular/common";

@Injectable(
  {
    providedIn:'root'
  }
)
export class TokenInterceptorService implements HttpInterceptor {

  _location: Location;

  constructor(private appUtil: AppUtilityService, private router: Router, location: Location) {
    this._location = location;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const user = this.appUtil.persistenceService().get('clientDetails');
    let token = '';
    if (user && (
      this._location.path().includes('individual') || this._location.path().includes('manager') ||
      this._location.path().includes('admin') || this._location.path().includes('institution') || this._location.path().includes('import'))) {
      token = "Bearer "+user.token.token;
      //check if token has expired then log out.
      var currentDate = new Date();
      let date = currentDate.getDate() <= 9 ? '0' + currentDate.getDate() : currentDate.getDate();
      let monthNo = (currentDate.getMonth() + 1) <= 9 ? '0' + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
      let hour = currentDate.getHours() <= 9 ? '0' + currentDate.getHours() : currentDate.getHours();
      let minutes = currentDate.getMinutes() <= 9 ? '0' + currentDate.getMinutes() : currentDate.getMinutes();
      var second = currentDate.getSeconds() <= 9 ? '0' + currentDate.getSeconds() : currentDate.getSeconds();
      var date_time = currentDate.getFullYear() + '-' + monthNo + '-' + date + 'T' + hour + ':' + minutes + ':' + second+ 'Z';
      var expiration=user.token.expiration.split(".")[0]+ 'Z';
      // console.log(date_time,"date time")
      // console.log(expiration,"expiration")
      var isAfter = moment(expiration).isAfter(date_time);
      if (!isAfter) {
        localStorage.clear();
        this.router.navigate(['/login']);
        this.appUtil.errorService().showErrorToast("Access has expired. Please log in again.");
      }
    }

    let tokenizedReq = req.clone({
      setHeaders:{Authorization:token?token:"",}
    });

    this.appUtil.loaderService().addLoader();
    return next.handle(tokenizedReq);
  }
}
